var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M 0.5 0.125 C 0.293 0.125 0.125 0.293 0.125 0.5 C 0.125 0.707 0.293 0.875 0.5 0.875 C 0.707 0.875 0.875 0.707 0.875 0.5 C 0.875 0.293 0.707 0.125 0.5 0.125 Z M 0 0.5 C 0 0.223 0.223 0 0.5 0 C 0.777 0 1 0.223 1 0.5 C 1 0.777 0.777 1 0.5 1 C 0.223 1 0 0.777 0 0.5 Z M 0 0.5 M 0.746 0.469 L 0.434 0.281 C 0.398 0.262 0.352 0.289 0.352 0.332 L 0.352 0.668 C 0.352 0.711 0.398 0.738 0.434 0.719 L 0.746 0.531 C 0.77 0.52 0.77 0.48 0.746 0.469 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.7df0626ea3f0c795c38dd4a0c8d85290.svg";
export { ForwardRef as ReactComponent };